var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex flex-column p-6 bgi-size-cover bgi-no-repeat rounded bg-warning"},[_c('h4',{staticClass:"d-flex flex-center rounded-top"},[_c('span',{staticClass:"text-black"},[_vm._v("Pendonor terdaftar hari ini")]),_c('span',{staticClass:"btn btn-text btn-success btn-sm font-weight-bold btn-font-md ml-2"},[_vm._v(" 0 ")])])])])
}]

export { render, staticRenderFns }